import { render } from "./InsuredProductsInformations.vue?vue&type=template&id=725fda5c"
import script from "./InsuredProductsInformations.vue?vue&type=script&lang=js"
export * from "./InsuredProductsInformations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__